import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAdminStore = create(
  persist(
    (set, get) => ({
      // État
      subscribers: [],
      administrators: [],
      settings: {},
      statistics: {},
      isLoading: false,
      error: null,
      lastSync: null,

      // Actions
      setSubscribers: (subscribers) => set({ subscribers }),
      setAdministrators: (administrators) => set({ administrators }),
      setSettings: (settings) => set({ settings }),
      setStatistics: (statistics) => set({ statistics }),
      setLoading: (isLoading) => set({ isLoading }),
      setError: (error) => set({ error }),
      setLastSync: (timestamp) => set({ lastSync: timestamp }),

      // Actions complexes
      addSubscriber: (subscriber) => {
        const { subscribers } = get();
        set({ subscribers: [...subscribers, subscriber] });
      },

      addAdministrator: (administrator) => {
        const { administrators } = get();
        set({ administrators: [...administrators, administrator] });
      },

      updateSubscriber: (id, data) => {
        const { subscribers } = get();
        set({
          subscribers: subscribers.map(sub =>
            sub.id === id ? { ...sub, ...data } : sub
          ),
        });
      },

      updateAdministrator: (id, data) => {
        const { administrators } = get();
        set({
          administrators: administrators.map(admin =>
            admin.id === id ? { ...admin, ...data } : admin
          ),
        });
      },

      // Synchronisation
      syncWithCloud: async () => {
        set({ isLoading: true, error: null });
        try {
          // TODO: Implémenter la synchronisation avec le cloud
          set({ lastSync: new Date().toISOString() });
        } catch (error) {
          set({ error: error.message });
        } finally {
          set({ isLoading: false });
        }
      },

      // Statistiques
      updateStatistics: async () => {
        set({ isLoading: true, error: null });
        try {
          // TODO: Implémenter la récupération des statistiques
          const stats = {
            totalSubscribers: get().subscribers.length,
            activeSubscribers: get().subscribers.filter(sub => sub.status === 'active').length,
            totalSales: 0, // À implémenter
            revenue: 0, // À implémenter
          };
          set({ statistics: stats });
        } catch (error) {
          set({ error: error.message });
        } finally {
          set({ isLoading: false });
        }
      },
    }),
    {
      name: 'admin-storage',
      partialize: (state) => ({
        subscribers: state.subscribers,
        administrators: state.administrators,
        settings: state.settings,
        statistics: state.statistics,
        lastSync: state.lastSync,
      }),
    }
  )
);

export default useAdminStore; 